import React, { useState } from "react";

// custom components
import CustomerForm from "components/CustomerForm/CustomerForm";

export default function QuoteHeader({ formik, ...otherProps }) {
    return (
        <CustomerForm
            formik={formik}
            isPickupAtDealership={formik.values.isPickupAtDealership === 1}
            {...otherProps}
        />
    );
}
